const HeaderOnMobile = {
  init() {
    var btnOpen = document.getElementById("header-toggle-icon-menu-open");
    var btnClose = document.getElementById("header-toggle-icon-menu-close");

    var toogle = function() {
      btnOpen.classList.toggle("hidden");
      btnClose.classList.toggle("hidden");

      document.getElementById("mobile-drop-menu").classList.toggle("hidden");
      document.getElementById("mobile-drop-menu").classList.toggle("flex");
    };

    btnOpen.addEventListener("click", toogle);
    btnClose.addEventListener("click", toogle);

    // var btnService = document.getElementById("mobile-menu-service");

    // btnService.addEventListener("click", function() {
    //   document.getElementById("mobile-dropdown-service").classList.toggle("hidden");

    //   document.getElementById("mobile-btn-toogle-service-1").classList.toggle("hidden");
    //   document.getElementById("mobile-btn-toogle-service-2").classList.toggle("hidden");
    // });
  },
};

export default HeaderOnMobile;
